

































import Vue from 'vue'
import { mapGetters } from 'vuex'
import { USER_NS } from '~/store/modules/shared/user/state'
export default Vue.extend({
  props: {
    name: { type: String, default: 'email' },
    customClass: { type: String, default: 'form-control' },
    value: { type: String, default: null },
    floatingLabelEnabled: { type: Boolean, default: false, required: false },
    floatingGreen: { type: Boolean, default: false, required: false },
    placeholder: { type: String, default: 'Email' },
    showInfo: { type: String, default: '', required: false },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    emailInputState: {
      type: [Boolean, null],
      default: null
    }
  },
  data() {
    return {
      email: null,
      email_validator:
        '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'
    }
  },
  computed: {
    ...mapGetters(USER_NS, {
      userIsAnon: 'isAnon'
    }),
    isValid() {
      let validator = false
      if (this.email) {
        const regex = this.email_validator
        validator = !!this.email.match(regex)
      } else {
        validator = true
      }

      this.$emit('validation', validator)
      return validator
    },
    realValue() {
      if (!this.email) {
        return null
      } else {
        return this.email
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (value) {
          try {
            value = JSON.parse(value)
          } catch (e) {}
        }

        value = value || null

        if (value) {
          this.email = value
        } else {
          this.email = null
        }
      }
    },
    realValue(value) {
      this.$emit('input', value)
      this.$emit('change')
    }
  }
})
